import { LabelItemType } from "@/types/view";
import { AppConstant, SystemConstant } from "@/const";
import { useTranslation } from "react-i18next";

const useResponseStatusList = () => {
  const { t: getLabel } = useTranslation();

  const reqStatusList: LabelItemType[] = [
    {
      value: AppConstant.SELECT_ALL,
      label: getLabel("OBJ_STATUS_REQUEST.all"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.success),
      label: getLabel("OBJ_STATUS_REQUEST.success"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.failed),
      label: getLabel("OBJ_STATUS_REQUEST.failed"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.approvedIncomingData),
      label: getLabel("OBJ_STATUS_REQUEST.processing"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.resolved),
      label: getLabel("OBJ_STATUS_REQUEST.resolved"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.rejected),
      label: getLabel("OBJ_STATUS_REQUEST.rejected"),
    },
  ];

  return reqStatusList;
};

export default useResponseStatusList;
